import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgPauseCircle = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.5 12a8.5 8.5 0 1 0 17 0 8.5 8.5 0 0 0-17 0m1.429 7.071A10 10 0 1 1 19.07 4.93 10 10 0 0 1 4.93 19.07M14 8.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75M10.75 9a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgPauseCircle;
